import { SAGA_ACTIONS } from '../../../_config';
import { useApiCall } from '../common/appApiCallHook';
import {
  ContentReq,
  DetailsReq,
  BlankReq,
  locationReq,
  SearchReq,
  editProfileReq,
  LoginReq,
} from '../../interfaces/ApiReqRes'


export function useUserApi() {

  const callApi = useApiCall()
  const login = (data: LoginReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError);
  }
  const register = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.REGISTER, data, onSuccess, onError);
  }

  const otpcheck = (data: any, onSuccess: Function, onError: Function) => {
    console.log('data...', data);
    callApi(SAGA_ACTIONS.USER.OTP, data, onSuccess, onError);
  }
  const guestRegister = (data: any, onSuccess: Function, onError: Function) => {
    console.log('data...', data);

    callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError);
  }

  const logout = (data: BlankReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LOGOUT, data, onSuccess, onError);
  }

  const editProfile = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.EDIT_PROFILE, data, onSuccess, onError);
  }
  const aboutMe = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.ME, data, onSuccess, onError);
  }

  const myOrders = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.MY_ORDERS, data, onSuccess, onError);
  }

  const orderDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.ORDER_DETAILS, data, onSuccess, onError);
  }


  const cancelOrder = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.CANCEL_ORDER, data, onSuccess, onError);
  }

  const resetPassword = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.RESET_PASSWORD, data, onSuccess, onError);
  }
  const forgotPassword = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.FORGOT_PASSWORD, data, onSuccess, onError);
  }




  /* 
    const registration = (data: RegistrationReq, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.REGISTRATION, data, onSuccess, onError);
    }
  
    const emailVerify = (data: EmailVerifyReq, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.VERIFY, data, onSuccess, onError);
    }
  
    const getUser = (data: EmailVerifyReq, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.GET_USER, data, onSuccess, onError);
    }
  
    const submitContact = (data: contactReq, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.CONTACT, data, onSuccess, onError);
    }
  
  
    const validToken = (data: EmailVerifyReq, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.VALID_TOKEN, data, onSuccess, onError);
    }
  
    const changePassword = (data: changePasswordReq, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.CHANGE_PASSWORD, data, onSuccess, onError);
    }
  
    const profileUpdate = (data: profileUpdateReq, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.PROFILE_UPDATE, data, onSuccess, onError);
    }
  
    const updateAvatar = (data: avatar, onSuccess: Function, onError: Function) => {
      callApi(SAGA_ACTIONS.USER.AVATAR, data, onSuccess, onError);
    } */

  return {
    login: login,
    logout: logout,
    editProfile: editProfile,
    aboutMe: aboutMe,
    myOrders: myOrders,
    orderDetails: orderDetails,
    resetPassword: resetPassword,
    forgotPassword: forgotPassword,
    cancelOrder: cancelOrder,
    register: register,
    guestRegister: guestRegister,
    otpcheck: otpcheck
    /* 
    callRegistration: registration,
    callEmailVerify: emailVerify,
    callGetUser: getUser,
    callLogout: logout,
    submitContact: submitContact,
    forgotPassword: forgotPassword,
    validToken: validToken,
    changePassword: changePassword,
    profileUpdate: profileUpdate,
    updateAvatar: updateAvatar */
  }
}